module.exports = __webpack_public_path__ + "img/tu5.9378c804.png";